<template>
    <div>
        <b-card :header="uLang('app.create')" header-tag="h4" class="bg-default-card">
            <form-admin-action-document />
        </b-card>
    </div>
</template>

<script>
    import FormAdminActionDocument from '~/components/forms/admin/action-document/form'

    export default {
        name: 'create',

        components: {
            'form-admin-action-document': FormAdminActionDocument,
        },
    }
</script>

<style lang="css" scoped>
</style>